export default __webpack_public_path__ + "static/media/ic-help-inactive.389a5b11.webp";